import { Icon } from '@/atoms'
import { Paragraph } from '@/atoms/Typography'
import React from 'react'
import { usePageContext } from '@contexts/PageContext'
import * as S from './styles'

const InsuranceCard = ({ icon, title, description }) => {
  const { pageContext } = usePageContext()
  return (
    <S.InsuranceCard pageContext={pageContext}>
      <S.InsuranceCardIcon>
        <Icon huge name={icon} />
      </S.InsuranceCardIcon>
      <S.InsuranceCardContent>
        <Paragraph
          typo='paragraphLG'
          bold
        >
          {title.content}
        </Paragraph>
        <Paragraph typo='paragraph1'>{description}</Paragraph>
      </S.InsuranceCardContent>
    </S.InsuranceCard>
  )
}

export default InsuranceCard
